"use client";

import { MessageCircle, Phone } from "lucide-react";
import Link from "next/link";
import { useAppSelector } from "@/hooks/hooks";
import { ISettings } from "@/types/home.types";

import { useState, useEffect } from "react";

export default function FloatingWhatsApp() {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const SettingList = useAppSelector((state) => state.home.SettingList);

  const Settings: Record<string, ISettings> = (SettingList || []).reduce(
    (acc, item) => {
      acc[item?.SettingKey] = item;
      return acc;
    },
    {} as Record<string, ISettings>
  );

  const whatsAppNo = Settings?.["WhatsAppNo"]?.SettingValue;
  const phoneNo = Settings?.["PhoneNo"]?.SettingValue;

  const whatsappLink = `https://wa.me/${whatsAppNo}`;
  const phoneLink = `tel:${phoneNo}`;

  if (!mounted) return null;

  return (
    <>
      {/* Call Button */}
      <Link
        href={phoneLink}
        className="fixed bottom-24 right-4 z-50 w-16 h-16 bg-pink-500 rounded-full flex items-center justify-center shadow-2xl hover:bg-pink-600 transition-all duration-300 hover:scale-110 animate-bounce"
        aria-label="Call Us"
      >
        <Phone className="w-7 h-7 text-white" />
      </Link>

      {/* WhatsApp Button */}
      <Link
        href={whatsappLink}
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-4 right-4 z-50 w-16 h-16 bg-green-500 rounded-full flex items-center justify-center shadow-2xl hover:bg-green-600 transition-all duration-300 hover:scale-110 animate-bounce"
        aria-label="Chat on WhatsApp"
      >
        <MessageCircle className="w-8 h-8 text-white" />
      </Link>
    </>
  );
}
